// Currencies that have no minor unit — amounts are already whole units, so the
// lowest-unit integer must NOT be divided by 100. Mirrors payment-provider
// zero-decimal currency list.
const ZERO_DECIMAL_CURRENCIES = new Set([
  'JPY',
  'KRW',
  'CLP',
  'VND',
  'BIF',
  'DJF',
  'GNF',
  'KMF',
  'MGA',
  'PYG',
  'RWF',
  'UGX',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
]);

/**
 * Format a payment amount expressed in a currency's lowest unit (e.g. cents)
 * into a localized display string. Zero-decimal currencies are not divided.
 */
export function formatCurrency(amountMinor: number, currencyCode: string): string {
  const code = (currencyCode || 'USD').toUpperCase();
  const isZeroDecimal = ZERO_DECIMAL_CURRENCIES.has(code);
  const value = isZeroDecimal ? amountMinor : amountMinor / 100;

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code,
    }).format(value);
  } catch {
    // Unknown currency code — fall back to a plain number with the code.
    return `${value.toLocaleString('en-US')} ${code}`;
  }
}
